/* eslint-disable */
export default {
    form_project_name_placeholder: "Vul hier de projectnaam in",
    form_value_can_not_be_empty: "Deze waarde kan niet leeg zijn",
    form_could_not_process_your_request: "Kan je verzoek niet verwerken",
    form_input_type_could_not_be_determined: "Er kan geen invoertype worden bepaald voor type:",
    form_could_not_find_form_field: "Er kan geen formulierveld gevonden worden met id:",
    form_submit: "Verstuur",
    form_loading_form: "Formulier wordt geladen",
    form_close: "Sluiten",
    form_organisation_name: "Organisatienaam",
    form_job_function_name: "Functienaam",
    form_job_function_name_placeholder: "Vul hier de functienaam in",
    form_organisation_name_placeholder: "Vul hier de naam van de organisatie in",
    form_project_name: "Projectnaam",
    form_project_product: "Product",
    form_option_product_selection: "Selectie",
    form_option_product_development: "Ontwikkel",
    form_option_product_selection_development: "Selecterend ontwikkel",
    form_option_nederlands: "Nederlands",
    form_option_engels: "Engels",
    form_account_first_name: "Voornaam",
    form_account_infix: "Tussenvoegsel",
    form_account_last_name: "Achternaam",
    form_account_gender: "Geslacht",
    form_account_has_role_email: "E-mailadres",
    form_account_has_role_language: "Taal",
    form_education_level: "Wat is het vereiste opleidingsniveau?",
    form_participant_session_appointment_date: "Afspraakdatum",
    form_comments: "Opmerkingen",
    form_consultant: "Consultant",
    form_option_male: "Man",
    form_option_female: "Vrouw",
    form_option_other: "Anders",
    form_participant_first_name_placeholder: "Vul de voornaam in van de deelnemer",
    form_participant_infix_placeholder: "Vul het tussenvoegsel in van de deelnemer",
    form_participant_last_name_placeholder: "Vul de achternaam in van de deelnemer",
    form_participant_email_placeholder: "Vul het e-mailadres in van de deelnemer",
    form_option_choose_language: "Kies een taal voor de deelnemer",
    form_participant_session_appointment_date_placeholder: "Selecteer een datum",
    form_comments_placeholder: "Voer je opmerkingen in",
    form_option_low: "MBO",
    form_option_middle: "HBO",
    form_option_high: "Academisch",
    form_email: "E-mailadres",
    form_account_email_placeholder: "Vul het e-mailadres in van de gebruiker",
    form_account_role_label: "Rol",
    form_display_name: "Weergavenaam",
    form_account_display_name_placeholder: "Vul een weergavenaam in voor de gebruiker",
    form_infix: "Tussenvoegsel",
    form_account_infix_placeholder: "Vul het tussenvoegsel in van de gebruiker",
    form_account_last_name_placeholder: "Vul de achternaam in van de gebruiker",
    form_last_name: "Achternaam",
    form_first_name: "Voornaam",
    form_account_first_name_placeholder: "Vul de voonaam in van de gebruiker",
    form_option_role_application_managers: "Applicatiebeheerder",
    form_option_role_consultants: "Consultant",
    form_option_role_bedrijfsbureau: "Planning & Support",
    form_option_role_backoffice: "Backoffice",
    form_option_role_client_center: "Client center",
    form_option_role_assessment_team: "Assessment team",
    form_option_role_assessors: "Assessor",
    form_gender: "Geslacht",
    form_option_choose_gender: "Kies een geslacht",
    form_stars_required: "* Verplichte velden",
    form_option_choose_education_level: "Kies een opleidingsniveau",
    form_option_choose_consultant: "Geen consultant gekozen",
    form_option_choose_product: "Kies een product",
    form_option_choose_user_role: "Kies een rol",
    form_error_not_blank: "Dit veld mag niet leeg zijn",
    form_error_length_maximum: "De waarde van dit veld is te lang",
    form_error_length_minimum: "De waarde van dit veld is te kort",
    form_error_duplicate_entry: "Deze waarde bestaat al",
    form_error_password_contains_spaces: "Het wachtwoord mag geen spaties bevatten",
    form_error_password_do_not_match: "De wachtwoorden komen niet overeen",
    form_error_password_too_short: "Het wachtwoord moet minimaal 8 karakters bevatten",
    form_error_password_too_long: "Het wachtwoord is te lang",
    form_error_invalid_email: "Het e-mailadres is ongeldig",
    form_error_duplicate_non_participant_role: "Deze gebruiker is al eerder uitgenodigd met de geselecteerde rol",
    form_error_invalid_field_value: "De waarde van dit veld is ongeldig",
    form_error_email_duplicate_in_project: "Deze deelnemer bestaat al",
    form_error_duplicate_custom_competency: "Deze competentie bestaat al",
    form_error_registration_user_already_exists: "Deze gebruiker bestaat al. Klik op inloggen of wachtwoord vergeten om verder te gaan.",
    form_cancel: "Annuleren",
    form_highest_basic_education_level: "Wat is je hoogst genoten opleidingsniveau in het voortgezet onderwijs?",
    form_highest_advanced_education_level: "Wat is je hoogst genoten opleidingsniveau in het hoger- of beroepsonderwijs?",
    form_highest_basic_education_level_placeholder: "Kies een opleidingsniveau",
    form_highest_advanced_education_level_placeholder: "Kies een opleidingsniveau",
    form_appendixes_to_hide_online: "Verborgen bijlagen",
    form_account_date_of_birth: "Geboortedatum",
    form_appendixes_to_hide_pdf: "Verborgen bijlagen",
    form_option_persona_fit: "Persona.fit",
    form_option_working_styles: "Werkstijlen",
    form_option_influencing_styles: "Beïnvloedingsstijlen",
    form_option_motives: "Drijfveren",
    form_option_personality: "Persoonlijkheid",
    form_option_intellectual_capabilities: "Intellectueel vermogen",
    form_error_participant_session_invite_failed: "E-mail versturen mislukt",
    form_form_fields_not_loaded: "Formuliervelden bestaan niet! API-aanroep is waarschijnlijk mislukt",
    update_participant_detail_save: "Opslaan",
    update_participant_detail_page_heading: "Persoonlijk profiel",
    update_participant_detail_form_heading: "Persoonlijke gegevens",
    update_participant_detail_form_heading_label: "Onderstaande gegevens zijn bij ons bekend",
    form_date_of_birth: "Geboortedatum",
    form_report_receivers_placeholder: "Rapportontvangers",
    form_report_receivers: "Rapportontvangers",
    form_sub_organisation_name_placeholder: "Vul hier de suborganisatie naam in",
    form_sub_organisation_name: "Suborganisatie naam",
    form_report_receiver_account_gender: "Geslacht",
    form_report_receiver_account_has_role_email: "E-mailadres",
    form_report_receiver_account_last_name: "Achternaam",
    form_report_receiver_account_infix: "Tussenvoegsel",
    form_report_receiver_account_first_name: "Voornaam",
    form_error_report_receiver_already_exists: "Deze rapportontvanger bestaat al, selecteer deze in de lijst",
    form_option_role_office_manager: "Office Manager",
    form_choose_organisations_title: "Organisaties",
    form_choose_project_title: "Project",
    form_product_selection: "Selectie",
    form_product_selection_development: "Selecterend ontwikkel",
    form_product_development: "Ontwikkel",
    form_many_participant_session_to_one_product: "Product",
    form_low: "MBO",
    form_high: "WO",
    form_middle: "HBO",
    form_male: "Man",
    form_other: "Anders",
    form_female: "Vrouw",
    form_one_participant_session_to_many_active_competency: "Competenties toevoegen",
    "form_nl-_n_l": "Nederlands",
    "form_en-_g_b": "Engels",
    form_product_building_docks: "Building Docks",
    form_product_talent_fit: "Talent Fit",
    form_product: "Product",
    form_error_not_email: "Het opgegeven e-mailadres is niet geldig",
    form_product_wpq: "WPQ",
    form_product_personafit2: "Persona.fit 2",
    form_product_wpq_description: "...",
    form_product_persona_fit2_description: "...",
    form_product_building_docks_description: "Geeft inzicht in hoe een deelnemer omgaat met morele dilemma’s.",
    form_product_talent_fit_description: "Snel en objectief de match bepalen tussen talent en werkomgeving (hbo/wofuncties). Met ontwikkeltips voor de deelnemer en interviewvragen voor de interviewer.",
    form_product_selection_description: "Geeft inzicht in de match tussen het profiel van een deelnemer en een specifieke functie.",
    form_product_selection_development_description: "Geeft inzicht in de match tussen het profiel van een deelnemer en een specifieke functie. Aangevuld met ontwikkeltips.",
    form_product_development_description: "Geeft inzicht in de kwaliteiten, ontwikkelpunten en ontwikkelbaarheid van een deelnemer.",
    form_error_selected_product_is_invalid_for_parent_organisation: "Het geselecteerde product is ongeldig voor deze organisatie",
    form_input_value_too_short: "De opgegeven waarde dient minimaal 2 en maximaal 255 karakters te bevatten.",
    form_input_value_too_long: "De opgegeven waarde dient minimaal 2 en maximaal 255 karakters te bevatten.",
    form_input_value_required: "Dit veld is verplicht.",
    form_choose_product_title: "Product",
    form_choose_completed_start_title: "Startdatum",
    form_choose_completed_end_title: "Einddatum",
    form_product_persona_fit_2: "Persona.fit",
    form_option_role_finance: "Finance admin",
    form_enable_ability_tests: "Capaciteitstest(en) afnemen",
    form_ps_report_receivers: "Rapportontvangers",
    form_product_talent_navigator_description: "Snel en objectief ontwikkelrapport met inzicht in sterke en ontwikkelpunten. Start om naar de ontwikkeling te kijken van een medewerker.",
    form_product_talent_navigator: "Talent Navigator",
    form_product_add_on_integrity: "Integriteit",
    form_product_add_on_integrity_description: "Deze focus geeft inzicht in hoeverre de deelnemer integer handelt. De rapportage geeft weer of de deelnemer meer vanuit het individuele of collectieve belang handelt gezien het profiel en de houding van de deelnemer.",
    form_is_demo_participant: "Is dit een demo deelnemer?",
    form_product_add_on: "Focus (optioneel)",
    form_option_role_client_admin: "Client Admin",
    form_product_pre_fit_description: "Snel de beste deelnemers identificeren voor de volgende stap in het selectieproces.",
    form_product_pre_fit: "Pre Fit",
    form_cost_heading: "Kostenplaats (optioneel)",
    form_choose_cap_test_domain: "Deze specifieke capaciteitentest(en) zijn onderdeel van het programma.",
    form_choose_cap_test_domain_helper_text: "Kies minimaal twee optionele domeinen om de betrouwbaarheid te vergroten. Wanneer je geen optioneel domein kiest, wordt de algemene g-test ingezet en zie je in het rapport de score op algemeen intellectueel vermogen. Let op: deze keuze heeft invloed op de testtijd.",
    "form_de-_d_e": "Duits",
    "form_fr-_f_r": "Frans",
    form_product_talent_scan_description: "Een online selectietool die je helpt om de meest talentvolle medewerkers voor mbo-functies te selecteren.",
    form_product_talent_scan: "Talent Scan",
    form_product_add_on_work_safely: "Veilig werken",
    form_product_add_on_dealing_with_resistance: "Omgaan met weerstand",
    form_product_add_on_derailment: "Omgaan met druk",
    form_password_show: "Toon",
    form_password_hide: "Verbergen",
    form_saved_changes: "Wijzigingen zijn opgeslagen",
    form_unsaved_changes: "Wijzigingen niet opgeslagen",
    form_save_button: "Opslaan",
    form_product_multi_phase: "2-Phase Talent Fit",
    form_product_multi_phase_description: "Een trapsgewijze online selectietool die helpt om de beste deelnemers te selecteren uit een grote groep sollicitanten.",
    form_choose_roles_subtitle: "Hieronder vind je de verschillende rollen binnen Neon. Kies een of meerdere rollen.",
    form_choose_roles_title: "Welke rol(len) wil je toevoegen?",
    form_choose_reports_title: "Welke rapporten mag de gebruiker zien?",
    form_choose_reports_subtitle: "Kies een van de onderstaande opties.",
    form_option_role_office_manager_no_report: "Coördinator",
    form_choose_organisations_subtitle: "Kies de organisatie waar de gebruiker toegang toe heeft.",
    form_choose_organisations_title_descriptive: "Aan welke organisatie wil je de gebruiker toevoegen?",
    form_choose_organisations_placeholder: "Kies organisatie",
    form_option_role_report_receiver: "Rapportontvanger",
    form_all_reports_title: "Alle rapporten",
    form_all_reports_description: "Hiermee kan je de rapporten zien van alle deelnemers die zelf zijn toegevoegd.",
    form_no_reports_title: "Geen rapporten",
    form_no_reports_description: "De gebruiker kan alleen deelnemers toevoegen maar ziet geen rapporten.",
    form_amend_roles_title: "Rol(len)",
    form_product_add_on_critical_thinking: "Kritisch redeneren",
    form_product_add_on_critical_thinking_description: "Deze add-on geeft inzicht in de mate waarop de deelnemer in staat is feiten en aannames te scheiden en daaropvolgend de juist conclusies te trekken.",
    form_product_add_on_derailment_description: "Deze add-on geeft inzicht in welk toxisch gedrag er onder druk naar boven kan komen bij de werknemer.",
    form_product_add_on_work_safely_description: "Deze add-on verschaft inzicht in de factoren die van invloed zijn op de risico’s op het op het gebied van veilig werken.",
    form_product_add_on_dealing_with_resistance_description: "De manier waarop de werknemer omgaat met weerstand is bepalend voor de werkprestaties. Deze add-on geeft inzicht in de risico’s.",
    form_product_add_on_no_extra_time: "Geen extra tijd",
    form_product_add_on_integrity_extra_time: "±45 minuten",
    form_product_add_on_critical_thinking_extra_time: "±30 minuten",
    form_product_team_and_organisation: "Team & Organisatie",
    form_product_team_and_organisation_description: "Dit product bevordert transparante communicatie en biedt intuïtieve samenwerkingstools, waardoor teams en organisaties elkaars perspectieven beter begrijpen en samenhang bevorderen.",
    form_product_add_on_dilemma_test: "Dilemma test",
    form_product_add_on_dilemma_test_description: "Een ethische dilemma-test evalueert het besluitvormingsproces in complexe situaties om ethische redenering te beoordelen. Het test het vermogen om scenario's te analyseren en weloverwogen oordelen te vellen op basis van morele principes.",
    form_product_add_on_dilemma_test_extra_time: "±30 minuten",
    form_download: "Downloaden",
    form_assessment_form_description: "Kies uit een online scan of een compleet assessment met een psycholoog.",
    form_assessment_form_title: "Kies je opzet",
    form_assessment_form_with_interpretation_title: "Live assessment",
    form_assessment_form_without_interpretation_title: "Online assessment",
    form_assessment_form_with_interpretation_description: "Deze optie kies je wanneer je aanvullend de duiding door een LTP psycholoog wil toevoegen. Hierdoor wordt een beslissing nemen nog makkelijker.",
    form_assessment_form_without_interpretation_description: "De standaard is een geautomatiseerd rapport na afronding van de vragenlijsten. Er is geen interpretatie vanuit een LTP psycholoog aanwezig.",
    form_assessment_form_without_interpretation_time_indication: "Geen extra tijd",
    form_assessment_form_with_interpretation_time_indication: "+ 3 - 8 uur op LTP locatie",
    form_points_of_attention: "Gebruik onderstaand veld om aanvullende gegevens te geven over de volgende onderwerpen.\n<ul>\n<li>Is een contextanalyse nodig, en zo ja met wie kan hierover contact worden opgenomen en op welke manier. Graag de volledige contactgegevens vermelden.\n</li><li>\nIdem voor een nabespreking.\n</li><li>\nZijn er overige punten van aandacht specifiek voor deze kandidaat?\n</li>\n</ul>",
    form_points_of_attention_placeholder: "Voeg aanvullende informatie voor het plannen van het assessment toe",
    form_project_prompt_name_placeholder: "Voeg hier de titel in van de rol welke gebruikt wordt in de AI prompts",
    form_project_prompt_description_placeholder: "Voeg hier informatie over de rol toe om te gebruiken in de AI prompts",
    form_assessment_interpretation_title: "Duiding",
    form_assessment_interpretation_description: "Door deze optie te selecteren, kun je duiding door een psycholoog toevoegen aan het online assessment.",
    form_assessment_interpretation_enabled: "Aan",
    form_assessment_interpretation_disabled: "Uit",
    form_product_test_ned: "TestNed Scan",
    form_product_test_ned_description: "Online scan als basis voor een aanstellingskeuring",
    form_product_test_ned_periodic: "TestNed Scan Periodiek",
    form_product_test_ned_periodic_description: "Periodieke keuringen",
    form_interpretation_basic: "Interpretatie Zilver",
    form_interpretation_compact: "Interpretatie Compact",
    form_interpretation_regular: "Interpretatie Goud",
    form_interpretation_premium: "Interpretatie Premium",
    form_file_uploader_button: "Bestand zoeken",
    form_profile_files_title: "2. Bestanden gekoppeld aan het profiel",
    form_error_password_not_valid: "Het wachtwoord moet minimaal 12 karakters bevatten, waarvan 1 hoofdletter, kleine letter, cijfer en speciaal karakter",
    form_assessment_goal_description: "Kies uit het ontwikkelpotentieel in kaart brengen, een selectievraagstuk of een combinatie van beide.",
    form_assessment_goal_title: "Bepaal je doel",
    form_assessment_form_development_description: "Verkrijg inzicht in het ontwikkelpotentieel",
    form_assessment_form_selection_development_description: "Vind de beste kandidaten voor een functie, rekening houdend met ontwikkelingspotentieel",
    form_assessment_form_selection_description: "Identificeer de meest geschikte kandidaten voor een functie",
    form_assessment_form_development_title: "Ontwikkel",
    form_assessment_form_selection_development_title: "Selecterend ontwikkel",
    form_assessment_form_selection_title: "Selectie",
    form_unspecified: "Dat zeg ik liever niet",
    form_option_unspecified: "Dat zeg ik liever niet",
    form_raf_product_selection: "Uitgebreid selecterend assessment",
    form_raf_product_selection_development: "Uitgebreid selecterend ontwikkelassessment",
    form_raf_product_development: "Uitgebreid ontwikkelassessment",
    form_interpretation_periodicAssessmentTestNed: "TestNed Scan Periodiek",
    form_language: "Voorkeurstaal",
    form_profile_cv_title: "1. Functieprofiel hier bijsluiten, CV wordt door kandidaat zelf bijgesloten.",
    form_plan_in_neon_toggle_label: "Plan de afspraak in NEON",
    form_participant_files_title: "3. Voeg deelnemersgerelateerde bestanden toe",
    form_product_no_online_scan: "Zonder online scan",
    form_product_no_online_scan_description: "Alleen voor kandidaten die al een online scan gedaan hebben met een apart rapport.",
    form_file_item_upload_fail: "Fout tijdens uploaden",
    form_file_item_upload_success: "Upload compleet",
    form_project_files_uploader_drag_and_drop: "Drag & Drop projectbestanden",
    form_files_uploader_remove_file_modal_description: "U staat op het punt een bestand te verwijderen. Dit betekent dat het bestand niet meer kan worden bekeken bij het schrijven van een rapport. Weet u zeker dat u het bestand wilt verwijderen?",
    form_files_uploader_remove_file_modal_delete_button: "Verwijderen",
    form_files_uploader_remove_file_modal_title: "Bestand verwijderen",
    form_files_uploader_error_upload: "Het bestand kon niet worden geüpload",
    form_files_uploader_error_delete: "Het bestand kon niet worden verwijderd",
    form_files_uploader_error_open: "Het bestand kon niet worden geopend",
    form_is_pre_assessment_call_necessary: "Is een gesprek vooraf met de manager nodig?",
    form_manager_name_placeholder: "Voer de volledige naam van de manager in",
    form_manager_phone_placeholder: "Voer het telefoonnummer van de manager in",
    form_manager_name_label: "Naam van de manager",
    form_manager_phone_label: "Telefoonnummer manager",
    form_report_receivers_add: "Nieuwe ontvanger toevoegen",
    form_report_receivers_empty_state_header: "Geen rapportontvangers geselecteerd",
    form_report_receivers_empty_state_paragraph_1: "Wilt u het rapport delen met een andere gebruiker?",
    form_report_receivers_empty_state_paragraph_2: "Zoek de gebruiker en selecteer deze of voeg een nieuwe gebruiker toe met de knop \"Nieuwe ontvanger toevoegen\"",
    form_update_button_label: "Update",
    form_report_receivers_remove_tooltip: "Verwijder",
    form_cv_uploader_drag_and_drop: "CV-bestand slepen",
    form_file_uploader_paragraph: "of klik om te bladeren",
    form_file_uploaded_success: "Het bestand is succesvol geüpload",
    form_education_level_description: "Het gewenste niveau is nodig om het juiste assessment te kunnen bieden voor jouw profiel. Het wordt ook gebruikt voor de capaciteitentests als deze onderdeel zijn van het programma.",
    form_education_level_title: "Wat is het gewenste niveau voor dit profiel?",
    form_education_level_low_description: "Dit profiel is een \"uitvoerend\" profiel waarbij de deelnemer vooral in de uitvoering werkt.",
    form_education_level_middle_description: "Dit profiel is een \"professioneel\" profiel waarbij de deelnemer naast uitvoering ook een beleidsmatige focus heeft.",
    form_education_level_high_description: "Dit profiel is een \"professioneel of uitvoerend\" profiel waarbij de deelnemer een beleidsmatige focus heeft of voor hogere executive functies.",
    form_education_level_high_title: "WO",
    form_education_level_middle_title: "HBO",
    form_education_level_low_title: "MBO",
    form_product_executive_scan: "Executive Scan",
    form_product_executive_scan_description: "Een scan voor executive functies gericht op het meten van leiderschapskwaliteiten, strategisch inzicht en persoonlijke effectiviteit, waarbij kritisch redeneren standaard onderdeel is van het programma.",
    form_error_email_contains_space: "E-mailadres mag geen spaties bevatten",
    form_interpretation_executive: "Compact Executive Assessment",
    form_interpretation_cLevel: "Executive Assessment",
    form_internal_participant_toggle_checked: "Ja, het rapport is alleen beschikbaar voor de rapportontvanger(s) van deze deelnemer",
    form_internal_participant_toggle_unchecked: "Nee, het rapport is beschikbaar voor collega's en rapportontvanger(s)",
    form_pre_assessment_call_toggle_unchecked: "Nee, het gesprek is niet nodig",
    form_points_of_attention_short: "Aandachtspunten",
    form_participant_phone_label: "Telefoonnummer van de deelnemer",
    form_participant_employee_number: "Personeelsnummer",
    form_invited_email_address: "Uitgenodigd e-mailadres",
    form_registered_email_address: "Geregistreerd e-mailadres",
    form_warning_email_addresses_different: "De e-mailadressen voor uitnodiging en registratie zijn niet gelijk",
    form_files_uploader_error_file_size: "Bestanden groter dan 5 MB kunnen niet worden geüpload",
    form_career_position_starter_title: "Starter",
    form_career_position_professional_title: "Professioneel",
    form_career_position_manager_title: "Manager",
    form_career_position_executive_title: "Executive",
    form_option_role_team_manager: "Team manager",
    form_option_role_team_admin: "Team admin"
};
